<template>
  <div style="margin-top:420px;">
    <div class="contents container-fluid">
      <div class="container" style="width: 1280px;">
        <div class="" style="width: 1280px; display: flex;flex-direction: row;justify-content: space-between;">
          <div style="width: 450px;">
            <div class="locations">
              <div class="texts hidden-sm hidden-xs">{{$utils.getShowYear()}}高考志愿优化系统</div>
              <!-- <div class="locationBtn" > -->
              <el-button v-show="$WebName" class="locationBtns" @click="changearea" type="text" style="padding: 0;">{{areaInfo.areaName}}
              </el-button>
              <!-- </div> -->
            </div>
          </div>
          <div style="width: 500px;">
            <div v-if="tianbaoType == 0">
              <el-radio-group v-model="scoreInfo.scoreSubject" class="selects" @change="changexuanke1">
                <div class="checkboxs">
                  <el-radio :label="1" :disabled="subjectDis">理科</el-radio>
                </div>
                <div class="checkboxs">
                  <el-radio :label="0" :disabled="subjectDis">文科</el-radio>
                </div>
              </el-radio-group>
            </div>
            <div class="selects" v-else>
              <el-radio-group v-model="xuanke1" class="selects" v-if="xuankeType == 1" @click="changexuanke1">
                <div class="checkboxs">
                  <el-radio label="wl" :disabled="subjectDis">物理</el-radio>
                </div>
                <div class="checkboxs">
                  <el-radio label="ls" :disabled="subjectDis">历史</el-radio>
                </div>
              </el-radio-group>
              <el-checkbox-group v-model="xuanke" class="selects" :max="maxlength" @change="changexuanke">
                <div class="checkboxs" v-if="xuankeType != 1">
                  <el-checkbox label="wl" :disabled="subjectDis">物理</el-checkbox>
                </div>
                <div class="checkboxs">
                  <el-checkbox label="hx" :disabled="subjectDis">化学</el-checkbox>
                </div>
                <div class="checkboxs">
                  <el-checkbox label="sw" :disabled="subjectDis">生物</el-checkbox>
                </div>
                <div class="checkboxs" v-if="xuankeType != 1">
                  <el-checkbox label="ls" :disabled="subjectDis">历史</el-checkbox>
                </div>
                <div class="checkboxs">
                  <el-checkbox label="dl" :disabled="subjectDis">地理</el-checkbox>
                </div>
                <div class="checkboxs">
                  <el-checkbox label="zz" :disabled="subjectDis">政治</el-checkbox>
                </div>
                <div class="checkboxs" v-if="xuankeArea.xingaokao6.indexOf(areaInfo.areaName)!=-1">
                  <el-checkbox label="xxjs" :disabled="subjectDis">信息技术</el-checkbox>
                </div>
              </el-checkbox-group>
            </div>
          </div>
          <div style="width: 400px;">
            <div class="searchs">
              <div class="inps">
                <input type="text" style="font-size: 12px;" v-model="scoreInfo.score" @input="getrank"
                  :readonly="subjectDis" placeholder="输入您的高考成绩">
              </div>
              <div class="inps">
                <input type="text" style="font-size: 12px;" v-model="scoreInfo.scoreRank" :readonly="subjectDis"
                  placeholder="输入您的高考位次" @click="openmessage">
              </div>
              <div class="searchBtns" @click="yuanxioa2" style="cursor: pointer;">
                开始优化
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="classifi">
      <div class="container-fluid top">
        <div class="container" style="width: 1280px;">
          <div class="row">
            <div class="col-lg-9 col-md-11 col-sm-11 col-xs-10">
              <div class="title">
                <img src="../images/home/trum.png" alt="">
                <span class="t hidden-xs">网站公告</span>
                <div class="text">
                  <transition name="slide" duration="2000">
                    <span class="text2" :key="text2.id" @click="openNewsDetail(text2.id)" >{{text2.val}}</span>
                  </transition>
                </div>

              </div>
            </div>
            <div class="col-lg-2 col-md-1 col-sm-1 col-xs-2 col-lg-push-1 col-md-push-0 col-sm-push-1">
              <div class="link" style="cursor: pointer;">更多</div>
            </div>
          </div>
        </div>
      </div>

      <div class="container-fluid">
        <div class="container" style="width: 1280px;">
          <div class="lists" style="width:1280px;justify-content: space-between;">
            <div class=" item">
              <div class="tail item1" @click="yuanzhiyuan">
                <div class="zhaodaxue" style="cursor:pointer">找大学</div>
                <div class="textss">院校简介 院系设置 开设专业 招生章程 录取分数</div>
              </div>
            </div>
            <div class=" item">
              <div class="tail item2" @click="zhaozhuanye">
                <div class="zhaodaxue" style="cursor:pointer">查专业</div>
                <div class="textss">专业详情 考研就业 开设院校</div>
              </div>
            </div>
            <div class=" item">
              <div class="tail item3" @click="yuanxiao">
                <div class="zhaodaxue" style="cursor:pointer">查分数</div>
                <div class="textss">院校分数  专业分数</div>
              </div>
            </div>
            <div class="item">
              <div class="item4 tail" @click="cegailv">
                <div class="zhaodaxue" style="cursor:pointer">测概率</div>
                <div class="textss">院校优先 专业优先测概率</div>
              </div>
            </div>
            <div class="item">
              <div class="item5 tail" @click="yuanxioa2()">
                <div class="zhaodaxue" style="cursor:pointer">填志愿</div>
                <div class="textss">院校优先 专业优先 </div>
              </div>
            </div>
            <div class="item">
              <div class="item6 tail" @click="zyd()">
                <div class="zhaodaxue" style="cursor:pointer">报告单</div>
                <div class="textss">查询、修改、打印、导出志愿单</div>
              </div>
            </div>
            <!-- <div class="item7">
              <div class="tail">
                <div class="zhaodaxue" style="cursor:pointer">暂无</div>
                <div class="textss">暂无</div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="选择服务省份" :visible.sync="dialogVisible" :lock-scroll="false" :show-close="false"
      :close-on-press-escape="false" :close-on-click-modal="false">
      <!-- 关闭提示 -->
      <!-- :before-close="handleClose" -->

      <!-- <span>这是一段信息</span> -->
      <ul class="diqu">
        <li v-for="item in AREA_LIST" :class="{active:areaInfo.areaId ==item.areaId }" @click="changeArea(item.areaId)">
          {{item.areaName}}
        </li>
      </ul>

      <!-- <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span> -->
    </el-dialog>
  </div>
</template>

<script>
  export default {
    components: {},
    data() {
      return {
        textArr: [],
        userInfo: "",
        tianbaoType: 0,
        xuankeType: 0,
        areaInfo: {},
        scoreInfo: {},
        number: 0,
        radio: 0,
        subjectDis: false,
        dialogVisible: false,
        AREA_LIST: this.$utils.getlocalStorage('AREA_LIST'),
        checkeds: [],
        xuankeArea: this.$utils.getlocalStorage('xuankeArea'),
        xuanke1: 'wl',
        xuanke: [],
        maxlength: 3,

      }
    },

    computed: {
      text2() {
        let _this = this;
        if (this.textArr.length != 0) {
          return {
            id: _this.textArr[_this.number].newsId,
            val: _this.textArr[_this.number].newsTitle
          }
        } else {
          return {
            id: '',
            val: ''
          }
        }

      }
    },
    mounted() {
      let _this = this;
      console.log(111)
      if(this.$WebName){
       if (_this.$utils.getlocalStorage('userInfo') == null || _this.$utils.getlocalStorage('userInfo').userProvinces ==
         null) {
         let geoc = new BMap.Geocoder(); //获取用户的地址解析。
         let native = new BMap.LocalCity(); //此类用于获取用户所在的城市位置信息
         native.get(function(r) {
           geoc.getLocation(r.center,
             function(rs) {
               let code = _this.$utils.getAreaCodeByName(rs.addressComponents.province)
               _this.changeArea(code);
             });
         });
       } else {
         this.userInfo = _this.$utils.getlocalStorage('userInfo')
       }
      } else {
        _this.changeArea(130000);
      }

      if (this.$utils.getlocalStorage('tianbaoType') != null) {
        this.tianbaoType = this.$utils.getlocalStorage('tianbaoType')
      }
      if (this.$utils.getlocalStorage('scoreInfo')) {
        this.scoreInfo = this.$utils.getlocalStorage('scoreInfo')
        this.scoreInfo.score = this.scoreInfo.score==0?"":this.scoreInfo.score
        setTimeout(function(){
         if (_this.tianbaoType != 0) {
           _this.xuanke = _this.scoreInfo.scoreXuanke.split(',')
           if (_this.xuankeType == 1) {
             _this.scoreInfo.scoreXuanke.indexOf('wl') != -1 ? _this.xuanke1 = 'wl' : _this.xuanke1 = 'ls'
           }
         }
        },0)


        this.subjectDis = true;
      }
      if (this.$utils.getlocalStorage('areaInfo')) {
        this.areaInfo = this.$utils.getlocalStorage('areaInfo')
        if (this.xuankeArea.xingaokao2.indexOf(this.areaInfo.areaName) != -1 || this.xuankeArea.xingaokao4.indexOf(this
            .areaInfo.areaName) != -1) {
          this.xuankeType = 1
        }
      }
      this.getqueryAllByArea()
    },
    methods: {
      changearea() {
        if (this.$utils.getlocalStorage('userInfo') == null) {
          this.dialogVisible = true;
        }
      },
      openNewsDetail(id){
        let url = this.$router.resolve({
        		path: '/newsDetail',
        		query: {id:id,Name:0,typeid:54,type:'kswd'}
        	})
        	window.open(url.href, '_blank')
      },
      changexuanke1() {
        if (this.tianbaoType == 2) {
          let a = this.xuanke1 == 'wl' ? 'ls' : 'wl'
          if (this.xuanke1 == 'wl') {
            this.scoreInfo.scoreSubject = 3
          } else {
            _this.scoreInfo.scoreSubject = 4
          }
          this.xuanke.unshift(this.xuanke1)
          this.xuanke = Array.from(new Set(this.xuanke))
          let b = this.xuanke.indexOf(a)
          if (b != -1) {
            this.xuanke.splice(b, 1);
          }
        }
        this.scoreInfo.score = ''
        this.scoreInfo.scoreRank = ''
      },
      changexuanke(ke) {
        this.scoreInfo.score = ''
        this.scoreInfo.scoreRank = ''
        console.log(this.xuanke)
      },
      getrank() {
        let _this = this;
        this.$nextTick(() => {
          _this.scoreInfo.scoreRank = ''
        })
        if (_this.scoreInfo.score == null || _this.scoreInfo.score == "") {
          return;
        }
        if (_this.scoreInfo.score < 120) {
          return;
        }
        if (_this.scoreInfo.score > 750) {
          this.$alert('请输入正确的考试成绩', {
            confirmButtonText: '确定',
            callback: action => {}
          })
          return;
        }
        _this.$req.getRankByscore({
          subject: _this.scoreInfo.scoreSubject,
          areaid: _this.areaInfo.areaId,
          score: _this.scoreInfo.score
        }).then(function(resp) {
          if (resp.status == 0 && resp.data != 0) {
            _this.scoreInfo.scoreRank = resp.data;
          }
        })
      },
      openmessage() {
        if (this.scoreInfo.score == null || this.scoreInfo.score == '') {
          this.$alert('请输入考生成绩', {
            confirmButtonText: '确定',
            callback: action => {}
          });
        }
      },
      changeArea(areaId) {
        console.log(1)
        let _this = this;
        _this.areaInfo = {
          areaId: areaId,
          areaName: _this.$utils.getlocalStorage('AREA_OBJ')[areaId],
          areaFullName: _this.$utils.getAreaFullName(areaId)
        }
        this.scoreInfo.score = ''
        this.scoreInfo.scoreRank = ''
        let area = _this.areaInfo.areaName
        let xuankeArea = _this.$utils.getlocalStorage('xuankeArea')
        if (xuankeArea.xingaokao2.indexOf(area) != -1 || xuankeArea.xingaokao4.indexOf(area) != -1) {
          _this.xuankeType = 1
        } else {
          _this.xuankeType = 0
        }
        if (xuankeArea.xingaokao.indexOf(area) == -1) {
          _this.$utils.setlocalStorage('tianbaoType', 0) //老高考
          _this.tianbaoType = 0
          _this.scoreInfo.scoreSubject = 1
        } else if (xuankeArea.xingaokao2.indexOf(area) != -1 || xuankeArea.xingaokao3.indexOf(area) !=
          -1) {
          _this.$utils.setlocalStorage('tianbaoType', 2) //专业组
          _this.tianbaoType = 2
          _this.scoreInfo.scoreSubject = 3
          _this.xuanke = []

          _this.changexuanke1()
        } else {
          _this.$utils.setlocalStorage('tianbaoType', 1) //单专业
          _this.tianbaoType = 1
          _this.xuanke = []
          _this.scoreInfo.scoreSubject = 2
        }
        _this.$utils.setlocalStorage('areaInfo', _this.areaInfo)
        _this.dialogVisible = false;
      },
      startMove() {
        // eslint-disable-next-line
        let timer = setTimeout(() => {
          if (this.number === this.textArr.length - 1) {
            this.number = 0
          } else {
            this.number += 1
          }
          this.startMove()
        }, 5000) // 滚动不需要停顿则将2000改成动画持续时间
      },
      getqueryAllByArea() {
        let _this = this;
        let areaId = "990000";
        if (_this.userInfo != null && _this.userInfo != "") {
          areaId = _this.userInfo.userProvinces
        }
        this.$req.queryAllByArea({
          areaId: areaId+"",
          newsIndexNewsType:54,
          newsStatus:1
        }).then(function(response) {
          _this.textArr = response.data
          _this.startMove()
        })
      },

      // 院校分
      yuanxiao() {
        if (this.$utils.tologin(this)) {
          if (this.$utils.getUserInfo(this)) {
            if (this.$utils.getFenshu(this)) {
              this.$router.push('/yuanxiaofen')
            }
          }
        }
      },
      cegailv() {
        if (this.$utils.tologin(this)) {
          if (this.$utils.getUserInfo(this)) {
            if (this.$utils.getFenshu(this)) {
              this.$router.push('/cegailv')
            }
          }

        }
      },

      // 专业填报  三种状态
      yuanxioa2() {
        if(this.$utils.getlocalStorage('userInfo') != null){
          if (this.$utils.getUserInfo(this)) {
            if (this.$utils.getFenshu(this)) {
              this.$router.push('/xuanzheyuanhuoye')
            }
          }
        } else{
          if (this.scoreInfo.score != null && this.scoreInfo.score != "") {
            this.$router.push('/xuanzheyuanhuoye')
          } else {
            this.$alert('请输入考生成绩', {
              confirmButtonText: '确定',
              callback: action => {}
            })
          }
        }
      },
      zyd() {
        if (this.$utils.tologin(this)) {
          this.$router.push('/grzx_wodezhiyuan')
        }


      },
      // 找大学或院校库
      yuanzhiyuan() {
        this.$router.push('/zyf')
      },
      // 查专业或专业库
      zhaozhuanye() {
        this.$router.push('/zhuanyezhiyuan')
      }
    }
  }
</script>

<style>
  .el-dialog {
    width: 900px;
  }

  .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
    background-color: #409EFF !important;
    border-color: #409EFF !important;
  }

  .contents {
    width: 100%;
    min-width: 1280px;
    height: 80px;
    background-color: rgba(0, 0, 0, 0.452);
    position: absolute;
    bottom: 0px;
    left: 0px;
    top: 340px;
    overflow: hidden;
  }

  .contents .locations {
    height: 80px;
    min-width: 270px;
    display: flex;
    align-items: center;
  }

  .contents .locations>.texts {
    font-size: 15px;
    color: #fff;
    line-height: 80px;
    font-weight: bold;
  }

  .contents .locations>.locationBtns {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 65px;
    margin-left: 6px;
    height: 22px;
    background-color: #01000048;
    color: #fff;
    font-size: 16px;
    line-height: 22px;
    border-radius: 5px;
    text-align: center;
    cursor: pointer;
  }

  .el-dialog {
    border-radius: 15px;
  }

  .el-icon-close:before {
    content: "\E78D";
    font-size: 23px;
  }

  .el-dialog__footer {
    display: flex;
    justify-content: center;
  }

  /* .el-button--primary{background: url(../images/home/quesdin.png)no-repeat;background-size: 100% 100%;border: none;}
  .el-button--primary:hover{background: url(../images/home/quesdin.png)no-repeat;background-size: 100% 100%;} */
  .diqu {
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
  }

  .diqu li {
    cursor: pointer;
    width: 80px;
    height: 34px;
    margin: 5px 5px;
    border: 1px solid #DCDFE6;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #606266;
  }

  .diqu li:hover {
    color: #FFFFFF;
    border: none;
    background: #FF6666;
  }

  .diqu .active {
    color: #FFFFFF;
    border: none;
    background: #FF6666;
  }

  .contents .selects {
    display: flex;
    height: 80px;
    /* min-width: 500px; */
    align-items: center;
    justify-content: flex-end;
  }

  .contents .selects>.checkboxs {
    margin: 0px;
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .contents .selects>.checkboxs .input {
    width: 14px;
    height: 14px;
    border-radius: 7px;
    outline: none;
    border: 1px solid #dedede;
    box-sizing: border-box;
    background-color: #00000000;
    margin-right: 3px;
  }

  .contents .selects>.checkboxs {
    margin: 0px;
    color: #fff;
    width: 65px;
  }

  .contents .selects>.checkboxs span {
    color: #ffffff;
  }

  .contents .searchs {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 80px;
    min-width: 370px;
  }

  .contents .searchs>div {
    margin: 0px 3px;
  }

  .contents .searchs>.inps {
    height: 30px;
  }

  .contents .searchs>.inps>input {
    height: 30px;
    width: 125px;
    border-radius: 5px;
    padding: 0px 5px;
    box-sizing: border-box;
    display: inline-block;
    box-sizing: border-box;
  }

  .contents .searchs>.searchBtns {
    height: 30px;
    width: 80px;
    flex-shrink: 0;
    text-align: center;
    background: linear-gradient(94deg, #ff9804, #f43626);
    border-radius: 5px;
    padding: 0px 10px;
    line-height: 30px;
    color: #fff;
  }

  .slide-enter-active,
  .slide-leave-active {
    transition: all 0.5s linear;
  }

  .slide-enter {
    width: 1000px !important;
    transform: translateY(20px) scale(1);
    opacity: 1;
  }

  .slide-leave-to {
    width: 1000px !important;
    transform: translateY(-20px) scale(0.8);
    opacity: 0;
  }

  .text2 {
    width: 330px;
    position: absolute;
    bottom: 0;
  }

  .slide-enter-active,
  .slide-leave-active {
    transition: all 0.5s linear;
  }

  .slide-enter {
    width: 100%;
    transform: translateY(20px) scale(1);
    opacity: 1;
  }

  .slide-leave-to {
    width: 100%;
    transform: translateY(-20px) scale(0.8);
    opacity: 0;
  }

  .classifi {}

  .classifi>.top {
    border-bottom: 1px solid #e6e6e6;
    padding: 9px 0px;
    overflow: hidden;
  }

  .classifi .title {
    display: flex;
  }

  .classifi .title>img {
    width: 26px;
    height: 23px;
  }

  .classifi .title>.t {
    flex-shrink: 0;
    white-space: nowrap;
    color: #333333;
    font-weight: bold;
    font-size: 15px;
    flex-shrink: 0px;
    width: 120px;
    margin: 0px 5px;
  }

  .classifi .title>.text {
    color: #333333;
    font-size: 15px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 20px;
    padding-top: 2px;
    flex: 1;
  }

  .classifi .title>.text span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 100%;
  }

  .classifi .link {
    color: #e23737;
    font-size: 15px;
  }

  .classifi .lists {
    display: flex;
    margin-top: 29px;
    flex-wrap: wrap;
  }

  .classifi .lists>div {
    width: 45%;
    height: 96px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    flex-wrap: 0;
    margin: 10px 10px;
    position: relative;
    border-radius: 15px;
    overflow: hidden;
    flex-shrink: 0;
  }

  .classifi .lists>div>.tail {
    position: absolute;
    bottom: 0px;
    display: flex;
    height: 50px;
    align-items: center;
    width: 100%;
    margin-bottom: 45px;
  }

  .classifi .lists>div>.tail>.line {
    width: 1px;
    height: 80%;
    color: #323037;
    background-color: #32303736;
  }

  .classifi .lists>div>.tail>.l,
  .classifi .lists>div>.tail>.r {
    height: 48px;
    font-size: 48px;
    font-family: YouSheBiaoTiYuan;
    font-weight: 400;
    color: #ffffff;
    text-shadow: 2px 2px 0px #f43626;
    opacity: 1;
    margin: 0 auto;
    margin-bottom: 20px;
  }

  .text2 {
    width: 850px;
  }

  .classifi {}

  .classifi>.top {
    border-bottom: 1px solid #e6e6e6;
    padding: 10px 0px;
    margin-top: 180px;
  }

  .classifi .title {
    display: flex;
  }

  .classifi .title>img {
    width: 26px;
    height: 23px;
  }

  .classifi .title>.t {
    color: #333333;
    font-weight: bold;
    font-size: 15px;
    flex-shrink: 0px;
    width: 80px;
    margin: 0px 5px;
  }

  .classifi .title>.text {
    color: #333333;
    font-size: 15px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .classifi .link {
    color: #e23737;
    font-size: 15px;
  }

  .classifi .lists {
    display: flex;
    margin-top: 15px;
    flex-wrap: nowrap;
  }

  .classifi .lists>div {
    width: 258px;
    height: 96px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    flex-wrap: 0;
    margin: 0px;
    padding: 0 10px;
    position: relative;
    border-radius: 15px;
    overflow: hidden;
  }

  .classifi .lists>div>.tail {
    position: initial;
    bottom: 0px;
    display: flex;
    height: 50px;
    border-radius: 15px;
    align-items: center;
    width: 100%;
  }

  .classifi .lists>div>.tail>.line {
    width: 1px;
    height: 80%;
    color: #323037;
    background-color: #32303736;
  }

  .classifi .lists>div>.tail>.l,
  .classifi .lists>div>.tail>.r {
    height: 48px;
    font-size: 38px;
    font-family: YouSheBiaoTiYuan;
    color: #ffffff;
    text-shadow: 2px 2px 0px #f43626;
    opacity: 1;
    margin: 0 auto;
    margin-bottom: 20px;
  }

  .classifi .lists>div>.tail>.l>img,
  .classifi .lists>div>.tail>.r>img {
    margin-left: 5px;
  }

  .classifi .lists>.item {
    width: 16% !important;
    height: 110px !important;
    padding: 0;
  }

  .classifi .lists>.item>.item1 {
    height: 100%;
    margin-bottom: 0;
    background-size: 100% 100%;
    background-image: url('../../../static/img/11.jpg');
  }

  .classifi .lists>.item>.item2 {
    height: 100%;
    margin-bottom: 0;
    background-size: 100% 100%;
    background-image: url('../../../static/img/22.jpg');
  }

  .classifi .lists>.item>.item3 {
    height: 100%;
    margin-bottom: 0;
    background-size: 100% 100%;
    background-image: url('../../../static/img/33.jpg');
  }

  .classifi .lists>.item>.item4 {
    height: 100%;
    margin-bottom: 0;
    background-size: 100% 100%;
    background-image: url('../../../static/img/44.jpg');
  }

  .classifi .lists>.item>.item5 {
    height: 100%;
    margin-bottom: 0;
    background-size: 100% 100%;
    /* background-color: #f53824; */
    background-image: url('../../../static/img/55.jpg');
  }

  .classifi .lists>.item>.item6 {
    height: 100%;
    margin-bottom: 0;
    background-size: 100% 100%;
    background: linear-gradient(137deg, #0019ff 0%, #0011b1 100%);
  }

  .classifi .lists>.item>.item7 {
    height: 100%;
    margin-bottom: 0;
    background-size: 100% 100%;
    background-image: url('../../../static/img/77.png');
  }



  .zhaodaxue {
    overflow: hidden;
    height: 48px;
    font-size: 34px;
    font-family: YouSheBiaoTiYuan;
    font-weight: 800;
    color: #ffffff;
    text-shadow: 2px 2px 0px #f43626;
    opacity: 1;
    margin: 0 auto;
    margin-bottom: 0px;
    transition: transform 0.5s;
  }

  .textss {
    width: 100%;
    margin-bottom: -200px;
    box-sizing: border-box;
    padding: 0 20px;
    position: absolute;
    z-index: 1;
        font-size: 15px;

    /* bottom: -50px; */
    left: 0;
    color: #fff;
    transition: transform 0.5s;
  }

  /* 找大学 */
  .item1:hover .zhaodaxue {
    transform: translateY(-20px);
  }

  .item1:hover .textss {
    transform: translateY(-75px);
  }

  /* 搜专业 */
  .item2:hover .zhaodaxue {
    transform: translateY(-20px);
  }

  .item2:hover .textss {
    transform: translateY(-75px);
  }

  /* 查分数 */
  .item3:hover .zhaodaxue {
    transform: translateY(-20px);
  }

  .item3:hover .textss {
    transform: translateY(-75px);
  }

  /* 测概率 */
  .item4:hover .zhaodaxue {
    transform: translateY(-20px);
  }

  .item4:hover .textss {
    transform: translateY(-75px);
  }

  /* 填志愿 */
  .item5:hover .zhaodaxue {
    transform: translateY(-20px);
  }

  .item5:hover .textss {
    transform: translateY(-75px);
  }

  /* 报告单 */
  .item6:hover .zhaodaxue {
    transform: translateY(-20px);
  }

  .item6:hover .textss {
    transform: translateY(-75px);
  }

  /* 暂无 */
  .item7:hover .zhaodaxue {
    transform: translateY(-20px);
  }

  .item7:hover .textss {
    transform: translateY(-75px);
  }
</style>



// WEBPACK FOOTER //
// src/views/home/classifi.vue